import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Privacy from './pages/Privacy/Privacy';
import Disclaimer from './pages/Disclaimer/Disclaimer';
import NotFound from './pages/404/404'; // 404ページ
import './App.css';

function App() {
  return (
    <Router>
      <div className="content">
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
